import axios from "@common/api/desktop/axios";

class Analysis {
  getMetaData = async (operator) => {
    const response = await axios.get(
      `Analysis/MetaData?operatorId=${operator}`,
    );
    response.data.filteredTimeGroupBy = response.data.timeGroupBy.filter((x) =>
      x.displayForDataSources.includes(response.data.dataSource[0].id),
    );
    response.data.measures = response.data.dataSource[0].measures;
    return response.data;
  };

  getGrid = async (
    fromDate,
    toDate,
    fromWeek,
    toWeek,
    startTime,
    endTime,
    dataType,
    dataTypes,
    totalBy,
    timeGroupById,
    dataGroupId,
    categoryIds,
    operatorId,
    companyId,
    subCompanyId,
    siteId,
    daysOfWeek,
    dataSourceId,
  ) => {
    const response = await axios.post(`Analysis/Grid`, {
      fromDate: fromDate.format("YYYY-MM-DD"),
      toDate: toDate.format("YYYY-MM-DD"),
      fromWeek,
      toWeek,
      startTime,
      endTime,
      dataType,
      dataTypes,
      totalBy,
      timeGroupById,
      dataGroupId,
      categoryIds,
      operatorId,
      companyId: companyId || -1,
      subCompanyId: subCompanyId || -1,
      siteId: siteId || -1,
      daysOfWeek,
      dataSourceId,
    });
    return response.data;
  };

  getGraph = async (
    selectedRows,
    fromDate,
    toDate,
    fromWeek,
    toWeek,
    startTime,
    endTime,
    dataType,
    dataTypes,
    totalBy,
    timeGroupById,
    dataGroupId,
    categoryIds,
    operatorId,
    companyId,
    subCompanyId,
    siteId,
    daysOfWeek,
    dataSourceId,
  ) => {
    const response = await axios.post(`Analysis/Graph`, {
      fromDate: fromDate.format("YYYY-MM-DD"),
      toDate: toDate.format("YYYY-MM-DD"),
      fromWeek,
      toWeek,
      startTime,
      endTime,
      rowKeys: selectedRows.map((row) => row.key),
      category: selectedRows.length > 1 ? null : selectedRows[0].category,
      dataType,
      dataTypes,
      totalBy,
      timeGroupById,
      dataGroupId,
      categoryIds,
      operatorId,
      companyId: companyId || -1,
      subCompanyId: subCompanyId || -1,
      siteId: siteId || -1,
      daysOfWeek,
      dataSourceId,
    });
    return response.data;
  };

  getGridByAsset = async (
    selectedRows,
    fromDate,
    toDate,
    fromWeek,
    toWeek,
    startTime,
    endTime,
    dataType,
    dataTypes,
    totalBy,
    timeGroupById,
    dataGroupId,
    categoryIds,
    operatorId,
    companyId,
    subCompanyId,
    siteId,
    daysOfWeek,
    dataSourceId,
  ) => {
    const response = await axios.post(`Analysis/Grid/ByAsset`, {
      fromDate: fromDate.format("YYYY-MM-DD"),
      toDate: toDate.format("YYYY-MM-DD"),
      fromWeek,
      toWeek,
      startTime,
      endTime,
      rowKeys: selectedRows.map((row) => row.key),
      category: selectedRows.length > 1 ? null : selectedRows[0].category,
      dataType,
      dataTypes,
      totalBy,
      timeGroupById,
      dataGroupId,
      categoryIds,
      operatorId,
      companyId: companyId || -1,
      subCompanyId: subCompanyId || -1,
      siteId: siteId || -1,
      daysOfWeek,
      dataSourceId,
    });
    return response.data;
  };

  getExport = async (
    emailAddress,
    fromDate,
    toDate,
    fromWeek,
    toWeek,
    startTime,
    endTime,
    dataType,
    dataTypes,
    totalBy,
    timeGroupById,
    dataGroupId,
    categoryIds,
    operatorId,
    companyId,
    subCompanyId,
    siteId,
    daysOfWeek,
    dataSourceId,
  ) => {
    const response = await axios.post(
      `Analysis/Export`,
      {
        emailAddress,
        fromDate: fromDate.format("YYYY-MM-DD"),
        toDate: toDate.format("YYYY-MM-DD"),
        fromWeek,
        toWeek,
        startTime,
        endTime,
        dataType,
        dataTypes,
        totalBy,
        timeGroupById,
        dataGroupId,
        categoryIds,
        operatorId,
        companyId: companyId || -1,
        subCompanyId: subCompanyId || -1,
        siteId: siteId || -1,
        daysOfWeek,
        dataSourceId,
      },
      { responseType: "arraybuffer" },
    );

    return response;
  };
}
const analysis = new Analysis();

export default analysis;
